var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.937 6.68C15.926 6.648 15.917 6.617 15.904 6.586C15.855 6.48 15.794 6.379 15.708 6.293L9.708 0.293C9.622 0.207 9.521 0.146 9.415 0.0969999C9.385 0.0829999 9.353 0.0749999 9.321 0.0639999C9.237 0.0359999 9.151 0.018 9.062 0.013C9.04 0.011 9.021 0 9 0H2C0.897 0 0 0.897 0 2V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V7C16 6.979 15.989 6.96 15.987 6.938C15.982 6.85 15.965 6.764 15.937 6.68ZM11.7324 5.14645C12.0474 5.46143 11.8243 6 11.3789 6H10.5C10.2239 6 10 5.77614 10 5.5V4.62111C10 4.17565 10.5386 3.95257 10.8536 4.26755L11.7324 5.14645ZM2.5 18C2.22386 18 2 17.7761 2 17.5V2.5C2 2.22386 2.22386 2 2.5 2H7.5C7.77614 2 8 2.22386 8 2.5V7C8 7.553 8.447 8 9 8H13.5001C13.7762 8 14 8.2238 14.0001 8.4999L14.0019 17.4999C14.002 17.7761 13.7781 18 13.5019 18H2.5Z",
    fill: "#0052CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d5f0c2ef.svg";
export { ForwardRef as ReactComponent };